<!-- 图文信息分页展示列表：模块头+图片+标题+分页 -->
<template>
<div class="content-block">
  <div class="info-list-title">
    <span>{{title}}</span>
    <label>{{label}}</label>
    <a href="#">更多</a>
  </div>
  <div class="info-list-content">
    <ul>
      <li v-for="news in newsList">
        <router-link :to="{path: '/details'}" v-bind:style='{backgroundImage:news.imgUrl}'>
          <label>{{news.title}}</label>
          <span>{{news.label}}</span>
          <span class="date">{{news.date}}</span>
        </router-link>
      </li>
    </ul>
    <pagination/>
  </div>
</div>
</template>

<script>
import Pagination from '../utils/Pagination'

export default {
  name: 'InfoPageList01',
  components:{'pagination':Pagination},
  props: {
    title: {
      type: String,
      default: ''
    },
    titleLength: {
      type: String,
      default: '16'
    },
    label: {
      type: String,
      default: ''
    },
    count: {
      type: String,
      default: '3'
    }
  },
  data() {
    return {
      newsList:[],
    }
  },
  created:function(){
    this.newsList=this.Global.newsListDemo.slice(0,this.count);
    console.log("当前导航页："+this.Global.siteDefaultNav);
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display:block;
  position:relative;
  margin: 0px 0px 1px 0px;
  padding:15px 5px 15px 1px;
  height:150px;
  text-align:left;
}

li a{
  display:block;
  height:120px;
  padding:0px 0px 0px 220px;
  background-color: #fff;
  background-size: 200px auto;
  background-repeat: no-repeat;
  background-position: 0px 0px;
}

li a label:hover{
  color:var(--color6);
  cursor:pointer;
}

a {
  color: #42b983;
  text-decoration: none;
}

li img{
  display:block;
  float:left;
  height:80px;
  padding-right:5px;
}

li label{
  display:block;
  font-size:16px;
  font-weight:500;
  color:#282A2B;
  line-height:30px;
  white-space:nowrap;
  overflow:hidden;
  text-overflow:ellipsis;
}

li span{
  display:block;
  padding-top:6px;
  font-size:12px;
  color:#9FA2A6;
  line-height:20px;
}

li .date{
  display:block;
  height:20px;
  padding-left:26px;
  position:absolute;
  bottom:15px;
  font-size:12px;
  color:#9FA2A6;
  line-height:10px;
  background-image:url(./../../assets/clock.png);
  background-size: 15px 15px;
  background-repeat: no-repeat;
  background-position: 0px 3px;
}



</style>



// WEBPACK FOOTER //
// src/components/block/InfoPageList01.vue